<script setup lang="ts">
import { PSeparator } from '@pokerly/ui';

interface Props {
    title: string;
    description?: string;
    values: (string | number)[];
}

defineProps<Props>();
</script>

<template>
    <div class="flex w-full min-w-0 flex-col items-center gap-4 text-center">
        <div class="paragraph-md w-full min-w-0 text-foreground-primary">
            <span class="block font-bold">{{ title }}</span>
            <span :title="values.join(', ')" class="block truncate">
                {{ values.join(', ') }}
            </span>
        </div>
        <template v-if="description">
            <div class="w-20 p-4">
                <PSeparator />
            </div>
            <span class="paragraph-sm text-foreground-muted">{{ description }}</span>
        </template>
    </div>
</template>

<style scoped></style>
